export default __webpack_public_path__ + "static/media/supergoop.c82ffc82.webp";